/*
 * Verschiebt die Slider-Navigationspfeile aus dem Sektionskopf in einen
 * relativen Stage um den Swiper — dann liegen sie seitlich auf halber
 * Hoehe (rechts/links am Content-Rand), analog zur PDP-Bildergalerie
 * (Feedback Georg 20.07.: Pfeile mittig statt darueber).
 *
 * Die Pfeile behalten ihre IDs (#swiper-button-prev-{id}), Swiper haelt die
 * Element-Referenz — Verschieben im DOM bricht die Klick-Verdrahtung nicht.
 * Die Produktgalerie ist ausgenommen (hat eigene .eg-gallery-stage-Pfeile).
 */
(function () {
  function relocate() {
    document.querySelectorAll('.grid-content__slider-nav').forEach(function (nav) {
      if (nav.dataset.egMoved) return;
      var scope =
        nav.closest('.container') ||
        nav.closest('.section__wrapper') ||
        nav.closest('.shopify-section');
      if (!scope) return;
      var swiper = scope.querySelector('swiper-container');
      if (!swiper || swiper.closest('.main-product')) return;
      var stage = swiper.parentElement;
      if (!stage) return;
      stage.classList.add('eg-slider-stage');
      stage.appendChild(nav);
      nav.dataset.egMoved = '1';
    });
  }
  function init() {
    relocate();
    // Product-Recommendations laden asynchron nach -> gezielt beobachten
    document.querySelectorAll('.product-recommendations').forEach(function (rec) {
      new MutationObserver(relocate).observe(rec, { childList: true });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', relocate);
  document.addEventListener('shopify:section:load', relocate);
})();
